import { InternalRevenueService } from "../../../../client"
import { useCreateWarehouseDocumentDraft } from "../../shared/useCreateWarehouseDocumentDraft"

// useCreatePW creates a persisted minimal PW draft and opens its detail editor.
export function useCreatePW() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft({
      mutationKey: ["wms", "internal-revenue", "pw"] as const,
      documentCode: "PW",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu PW.",
      createDraftRequest: (payload: { warehouse_id: string }) =>
        InternalRevenueService.initDocumentPWDraft(payload),
      buildPayload: (warehouseId: string) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft) => ({
        to: "/WMS/documents/doc-pw/$docPw",
        params: { docPw: draft.id },
        search: { tab: "general", edit: 1 },
      }),
    })
  return {
    createPW: (preferredWarehouseId?: string) =>
      createDocument({ preferredWarehouseId }),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
